"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerStatusValidation = void 0;
class ChargerStatusValidation {
    static isValid(entity) {
        // Validate entity.available for existence and correct type.
        if (entity.available == undefined)
            return false;
        if (typeof entity.available !== "boolean")
            return false;
        // Validate entity.software_version for existence and correct type.
        if (entity.software_version == undefined)
            return false;
        if (typeof entity.software_version !== "string")
            return false;
        // If entity.power_limited_high_utilization exists, validate that it has the correct type.
        if (entity.power_limited_high_utilization != undefined) {
            if (typeof entity.power_limited_high_utilization !== "boolean")
                return false;
        }
        // If entity.e_stop_pressed exists, validate that it has the correct type.
        if (entity.e_stop_pressed != undefined) {
            if (typeof entity.e_stop_pressed !== "boolean")
                return false;
        }
        // If entity.other_e_stop_pressed exists, validate that it has the correct type.
        if (entity.other_e_stop_pressed != undefined) {
            if (typeof entity.other_e_stop_pressed !== "boolean")
                return false;
        }
        return true;
    }
}
exports.ChargerStatusValidation = ChargerStatusValidation;
